import { render } from "./BriefingSection.vue?vue&type=template&id=4f4fba6c&scoped=true"
import script from "./BriefingSection.vue?vue&type=script&lang=js"
export * from "./BriefingSection.vue?vue&type=script&lang=js"

import "./BriefingSection.vue?vue&type=style&index=0&id=4f4fba6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f4fba6c"]])

export default __exports__